module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6wwYG"))).then(() => module.bundle.root('37nVf'));